module.exports = __webpack_public_path__ + "static/assets/f0d755c95b2c67c338acc2102b3bda44.svg";